import { defineStore } from 'pinia'
import { USER_INFO } from '/@/stores/constant/cacheKey'
import type { UserInfo } from '/@/stores/interface'
import { postLogout } from '/@/api/frontend/user/index'
import { refreshUserWord } from '../api/frontend/apply/user'
import { Local } from '/@/utils/storage'
import router from '../router'
import { ElNotification } from 'element-plus'

export const useUserInfo = defineStore('userInfo', {
    state: (): UserInfo => {
        return {
            id: 0,
            username: '',
            nickname: '',
            email: '',
            mobile: '',
            avatar: '',
            gender: 0,
            group_id: 0,
            birthday: '',
            money: 0,
            score: 0,
            enterprise_user: 0,
            last_login_time: '',
            last_login_ip: '',
            join_time: '',
            motto: '',
            token: '',
            refresh_token: '',
            app_token: '',
            scoreTimerId: null, // 添加定时器ID
        }
    },
    actions: {
        removeToken() {
            this.token = ''
            this.refresh_token = ''
        },
        dataFill(state: UserInfo) {
            this.$state = { ...this.$state, ...state }
        },
        setToken(token: string, type: 'auth' | 'refresh') {
            const field = type == 'auth' ? 'token' : 'refresh_token'
            this[field] = token
        },
        getToken(type: 'auth' | 'refresh' = 'auth') {
            return type === 'auth' ? this.token : this.refresh_token
        },
        getGenderIcon() {
            let icon = { name: 'fa fa-transgender-alt', color: 'var(--el-text-color-secondary)' }
            switch (this.gender) {
                case 1:
                    icon = { name: 'fa fa-mars-stroke-v', color: 'var(--el-color-primary)' }
                    break
                case 2:
                    icon = { name: 'fa fa-mars-stroke', color: 'var(--el-color-danger)' }
                    break
            }
            return icon
        },
        logout() {
            postLogout().then(async (res) => {
                if (res.code == 1) {
                    // 清理定时器
                    this.stopScoreTimer()

                    Local.remove(USER_INFO)
                    Local.remove('uniteInfo')

                    await router.push('/')
                    router.go(0)
                }
            })
        },
        isLogin() {
            return this.id && this.token
        },
        async refreshWordCount(isTip: boolean = true) {
            if (this.isLogin()) {
                const res = await refreshUserWord()
                if (res.code == 1) {
                    this.score = res.data.score
                    this.money = res.data.money
                    if (isTip) {
                        ElNotification.success({
                            // message: `字数剩余：${res.data.score}，积分剩余：${res.data.money * 100}`,
                            message: `字数剩余：${res.data.score}，积分剩余：${res.data.money}`,
                        })

                    }
                }
            }
        },
        isSubAccount() {
            return this.enterprise_user !== 0
        },

        // 定时器ID，用于清理
        scoreTimerId: null as NodeJS.Timeout | null,

        // 定时更新用户score，当前pinia初始化之后就开始执行定时器
        startScoreTimer(isTip: boolean = true) {
            // 如果已经存在定时器，先清除
            if (this.scoreTimerId) {
                clearInterval(this.scoreTimerId)
            }
            if (!this.isLogin()) {
                return
            }
            // 创建新的定时器
            this.scoreTimerId = setInterval(async () => {
                try {
                    await this.refreshWordCount(isTip)
                } catch (error) {
                    console.error('刷新用户字数失败:', error)
                    // 可以选择在失败时停止定时器或者继续重试
                }
            }, 5000)
        },

        // 停止定时器
        stopScoreTimer() {
            if (this.scoreTimerId) {
                clearInterval(this.scoreTimerId)
                this.scoreTimerId = null
            }
        }
    },
    persist: {
        key: USER_INFO,
    },
})
